import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "addTime",
})
export class AddTimePipe implements PipeTransform {
  transform(value: Date, amount: number, unit: "minutes" | "hours" | "days"): Date {
    if (!value) {
      return null;
    }

    const result = new Date(value);

    switch (unit) {
      case "minutes":
        result.setMinutes(result.getMinutes() + amount);
        break;
      case "hours":
        result.setHours(result.getHours() + amount);
        break;
      case "days":
        result.setDate(result.getDate() + amount);
        break;
      default:
        result;
        break;
    }

    return result;
  }
}
